let AbstractLogicalGeometryOperationResult = require('./abstractLogicalOperationResult');

/**
 * Класс IsTouchedResult определяет структуру результата логической проверки на касание одного объекта другим
 * @extends AbstractLogicalGeometryOperationResult
 */
class IsTouchedResult extends AbstractLogicalGeometryOperationResult {
  /**
   * Создает экземпляр класса IsTouchedResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IsTouchedResult";
  }
}

module.exports = IsTouchedResult;